// import { supabase } from '@/supabase.config';
// import { setAuthPersistence } from '@/supabase.config';
import Cookies from 'js-cookie';

import { apiService } from '../api/apiConfig';
import { store } from '../store';
import { setUser } from '../store/slices/auth';
import { AuthResponse, SignupCredentials } from './types/auth.types';

const handleAuthSuccess = (response: AuthResponse): void => {
  // Cookies.set('jwtToken', response.token);
  // Cookies.set('refreshToken', response.refreshToken);
  // store.dispatch(setUser(response.user));
};

const handleAuthError = (error: any): Error => {
  clearAuth();
  return error instanceof Error ? error : new Error('Authentication failed');
};

const clearAuth = (): void => {
  Cookies.remove('supabaseToken');
  Cookies.remove('refreshToken');
  store.dispatch(setUser(null));
};

export const setUserInStore = (userData: any): void => {
  const { email, user_metadata, id } = userData;
  const displayName = user_metadata?.full_name || user_metadata?.display_name;

  // Handle case where displayName might be null
  let firstName = '';
  let lastName = '';

  if (displayName) {
    const nameParts = displayName.split(' ');
    firstName = nameParts[0];
    lastName = nameParts.slice(1).join(' ');
  }

  // Store user in Redux
  store.dispatch(
    setUser({
      firstName,
      lastName,
      name: displayName || email,
      email,
      phoneNumber: user_metadata?.phone || '',
      photoURL: user_metadata?.avatar_url || '',
      id: id
    })
  );
};

export const authService = {
  signup: async (credentials: SignupCredentials, clerkSignUp: any): Promise<boolean> => {
    try {
      // 1. Create user with Clerk (sends verification email automatically)
      const signUpAttempt = await clerkSignUp.create({
        emailAddress: credentials.email,
        password: credentials.password
      });

      console.log('SignUp status:', signUpAttempt.status);

      // 2. Handle different statuses
      if (signUpAttempt.status === 'missing_requirements') {
        // Verification required - Clerk sends email automatically
        await signUpAttempt.prepareEmailAddressVerification({
          strategy: 'email_link' // Uses link from Clerk settings
        });

        // User needs to verify email before proceeding
        throw new Error('VERIFICATION_REQUIRED:Please check your email to verify your account');
      }
      // // 1. Backend creates the Clerk user and saves to database
      // const response = await apiService.request<AuthResponse>({
      //   method: 'POST',
      //   url: '/auth/sign-up',
      //   data: credentials
      // });

      // // 2. Sign in with Clerk to get session
      // // Note: clerkSignIn will be passed from component
      // const signInAttempt = await clerkSignIn.create({
      //   identifier: credentials.email,
      //   password: credentials.password
      // });

      // if (signInAttempt.status === 'complete') {
      //   // Session is now active, token will be available via getToken()
      //   handleAuthSuccess(response);
      //   return response;
      // } else {
      //   console.log('Sign in incomplete after signup');
      //   throw new Error('Sign in incomplete after signup');
      // }

      // 3. Store the token
      // const supabaseToken = authData.session.access_token;
      // Cookies.set('supabaseToken', supabaseToken);

      // handleAuthSuccess(response);
      return true;
    } catch (error) {
      throw handleAuthError(error);
    }
  },

  login: async (
    credentials: { email: string; password: string },
    rememberMe = false,
    clerkSignIn: any,
    clerkSignOut: any
  ): Promise<void> => {
    try {
      // Set login loading state to prevent premature redirects
      localStorage.setItem('loginInProgress', 'true');

      // Sign in with Clerk
      const signInAttempt = await clerkSignIn.create({
        identifier: credentials.email,
        password: credentials.password
      });

      if (signInAttempt.status !== 'complete') {
        throw new Error('Sign in failed');
      }

      console.log('Sign in completed successfully');

      // Clear login loading state after successful completion
      localStorage.removeItem('loginInProgress');
    } catch (error) {
      // Clear login loading state and sign out on error
      localStorage.removeItem('loginInProgress');
      throw handleAuthError(error);
    }
  },

  logout: async (clerkSignOut: any): Promise<void> => {
    try {
      // Sign out from Clerk
      await clerkSignOut();

      // Clear cookies and local state
      clearAuth();

      // Remove any rememberMe preference and login progress state
      localStorage.removeItem('rememberMe');
      localStorage.removeItem('loginInProgress');
      localStorage.removeItem('authPersistence');

      // Clear session persistence flags
      localStorage.removeItem('clerkAuthSession');
      sessionStorage.removeItem('clerkAuthSession');
    } catch (error) {
      throw new Error('Logout failed');
    }
  },

  // refreshToken: async (refreshToken: string): Promise<void> => {
  //   try {
  //     // Supabase handles token refresh automatically
  //     // But if you need manual refresh:
  //     const { data, error } = await supabase.auth.refreshSession();

  //     if (error) throw error;
  //     if (data.session) {
  //       Cookies.set('supabaseToken', data.session.access_token);
  //     }
  //   } catch (error) {
  //     clearAuth();
  //     throw error;
  //   }
  // },

  isAuthenticated: (isSignedIn: boolean): boolean => {
    const loginInProgress = localStorage.getItem('loginInProgress') === 'true';
    if (loginInProgress) {
      return false;
    }
    return isSignedIn;
  },

  // Method to check if the user is already authenticated
  getCurrentUser: (user: any) => {
    return user;
  }
};
